import { Divider, Select, Spin } from 'antd';
import React, {
    Fragment,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import CardEmail from './CardEmail';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import useQuery from '../../../util/useQuery';
import UserService from '../../../services/UserService';

export default function Related({ form, emailList, loading, isEditable }) {
    const [listEmail, setListEmail] = useState([]);
    let navigate = useNavigate();
    const params = useQuery();

    const currentPackage = UserService.currentPackage();

    const filterEmailByPackage = useCallback(
        (emailList) => {
            if (currentPackage === 2) {
                return emailList?.filter((email) => email.category !== 'DS360');
            }
            return emailList;
        },
        [currentPackage]
    );

    const filterEmail = (filter) => {
        if (filter === 'all') {
            return emailList;
        }
        return emailList?.filter((email) => email.category === filter);
    };

    const handleChange = (value) => {
        setListEmail(filterEmailByPackage(filterEmail(value)));
    };

    useEffect(() => {
        setListEmail(filterEmailByPackage(emailList));
    }, [emailList, filterEmailByPackage]);

    useEffect(() => {
        if (!params.get('id') && emailList.length > 0) {
            navigate(
                ROUTER.CONFIGURATION.EMAIL_SETTING +
                    `?id=${emailList[0]?.customizeEmailId}`
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailList, params.get('id')]);

    const options = useMemo(() => {
        if (currentPackage === 2) {
            return [
                {
                    value: 'all',
                    label: 'All Menu',
                },
                {
                    value: 'Consent',
                    label: 'Consent Management',
                },
            ];
        } else
            return [
                {
                    value: 'all',
                    label: 'All Menu',
                },
                {
                    value: 'DS360',
                    label: 'Data Subject 360',
                },
                {
                    value: 'Consent',
                    label: 'Consent Management',
                },
            ];
    }, [currentPackage]);

    return (
        <Fragment>
            <div className="px-4 pt-4">
                <div className="font-semibold">Related Menu Filter</div>
                <Select
                    className="mt-2"
                    defaultValue="all"
                    size="large"
                    style={{ width: '100%' }}
                    onChange={handleChange}
                    options={options}
                />
            </div>
            <Divider />
            <div className="flex justify-between items-center pb-6 px-4">
                <div className="font-semibold text-xl">
                    รายการอีเมลที่มีการส่งออกจากระบบ
                </div>
                <div className="font-semibold text-gray-400">
                    ทั้งหมด {listEmail.length} รายการ
                </div>
            </div>
            <div
                className="h-[58vh] overflow-auto overflow-x-hidden relative"
                style={{
                    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
                }}
            >
                <Spin spinning={loading}>
                    {listEmail.map((email) => (
                        <CardEmail
                            isEditable={isEditable}
                            form={form}
                            key={email.id}
                            email={email}
                        />
                    ))}
                </Spin>
            </div>
        </Fragment>
    );
}
